import I18n from 'i18n-js';
import { bool, func, string } from 'prop-types';

import BottomPopupWithTransition from '~/components/BottomPopupWithTransition';
import Body from '~/components/SubscriptionOverview/NewView/PopupsSection/DiscordPopup/Body';
import Footer from '~/components/SubscriptionOverview/NewView/PopupsSection/DiscordPopup/Footer';

import styles from './DiscordPopup.module.scss';

export default function DiscordPopup({ discordUrl, show, toggleShow }) {
  return (
    <BottomPopupWithTransition
      banner={I18n.t('season_ticket_welcome_headline_2')}
      bannerClassName={styles.banner}
      body={<Body />}
      closeButtonClassName={styles.closeButton}
      closeButtonEnabled
      containerClassName={styles.popup}
      footer={<Footer discordUrl={discordUrl} />}
      onClose={toggleShow}
      show={show}
    />
  );
}

DiscordPopup.propTypes = {
  discordUrl: string,
  show: bool,
  toggleShow: func,
};
